import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const getProjectTemplateSpace = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>{
        var _ref;
        var _project_data_templateId;
        return (_ref = (_project_data_templateId = project.data[templateId]) === null || _project_data_templateId === void 0 ? void 0 : _project_data_templateId.spaceList) !== null && _ref !== void 0 ? _ref : {};
    });
export const useProjectTemplateSpaces = ()=>{
    const templateId = useActiveTemplateId();
    const templateObject = useMemo(getProjectTemplateSpace, []);
    return useSelector((state)=>templateObject(state, templateId));
};
